export default __webpack_public_path__ + "static/media/add-place-img.a09d439b.png";